import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import cachedHttp from 'framework-asset-preview-lib/internal/shared/api/cachedHttp';
export function fetchSocialDetails(crmObject) {
  const broadcastId = getPropertyValue(crmObject, 'hs_origin_asset_id');
  return cachedHttp.get(`broadcast/v2/broadcasts/${broadcastId}`);
}
export function fetchSocialBroadcastChannels() {
  return cachedHttp.get(`broadcast/v2/channels`);
}
export function fetchSocialBroadcastPerformance(crmObject, socialChannel) {
  return cachedHttp.get(`social-reporting/v1/posts/${socialChannel.channelSlug}/${socialChannel.channelId}/${getPropertyValue(crmObject, 'hs_foreign_id')}`, {
    query: {
      includeTargetLabels: true
    }
  });
}